/**
 * Offer settle — what the offer buyer posts to
 * `POST /api/offers/[id]/settle` after they capture the buyer-side
 * PayPal/Stripe payment for an accepted offer. The server then promotes the
 * pending `seller_orders` row to settled and notifies the seller. The settle
 * path is web-only (mobile never hits it; the offer-checkout UI lives only in
 * the web app).
 *
 * Body is one field — `orderId` — pointing at the order created during the
 * accepting capture. All DB-state / state-machine / auth invariants
 * (offer belongs to this buyer, status == "accepted" not yet "settled",
 * deadline not expired) stay inline in `performOfferSettle` — the boundary
 * parse is shape-only.
 *
 * @see app/api/offers/[id]/settle/route.ts — handler
 * @see lib/offers/offer-settle.ts performOfferSettle — semantic invariants
 * @see components/offers/offer-checkout-sheet.tsx — caller
 * @see .tondocs/payments/API_REQUEST_BOUNDARY_AUDIT.md CRITICAL-4b
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface OfferSettleRequest {
  /** `orders.id` of the row written during the accepting capture. */
  orderId: string;
}

export const OfferSettleRequestSchema = pinned<OfferSettleRequest>()(
  z.object({
    orderId: z.string().min(1),
  }),
);
